import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class RefundsApi {
  static getRefundsForFacility = (filters, sort) => {
    return axios.post(
      API_BASE_URL + '/refundlist_paginated',
      RefundsApi.handleSortAndFilters(filters, sort),
    );
  };

  static getRefundsForApproval = (filters, sort) => {
    return axios.post(
      API_BASE_URL + '/refunds-for-approval',
      RefundsApi.handleSortAndFilters(filters, sort),
    );
  };

  static getRefundsForException = (filters, sort) => {
    return axios.post(
      API_BASE_URL + '/refunds-for-processing-exceptions',
      RefundsApi.handleSortAndFilters(filters, sort),
    );
  };

  static getRefundsForExceptionCommunication = (filters, sort) => {
    return axios.post(
      API_BASE_URL + '/refunds-for-communication-exceptions',
      RefundsApi.handleSortAndFilters(filters, sort),
    );
  };

  static getAllowedRefundTypes = (organizationId) => {
    return axios.get(
      API_BASE_URL +
        '/allowed_refund_types' +
        (organizationId ? `?organization_id=${organizationId}` : ''),
    );
  };

  static downloadECheck = (id, requestType = 'download', comment = '') => {
    return axios.get(API_BASE_URL + `/download-echeck/${id}`, {
      params: { requestType, ...(comment && { comment }) },
      responseType: 'blob',
    });
  };

  static sendECheckEmail = (id, comment = '') => {
    return axios.get(API_BASE_URL + `/send-echeck-email/${id}`, {
      params: comment ? { comment } : undefined,
    });
  };

  static getECheckAuditLogs = (transactionId) => {
    return axios.get(
      API_BASE_URL + `/transactions/${transactionId}/echeck-audit-logs`,
    );
  };

  static handleSortAndFilters = (filters, sort) => {
    return {
      // filters
      refundType: filters.payeeCategory,
      refundStatus: filters.status || undefined,
      startDate: filters.startDate,
      dateFilterType: filters.dateFilterType,
      endDate: filters.endDate,
      facility_id: filters.facility,
      facility_group_id: filters.facilityGroupId || undefined,
      search: filters.search,
      refundMethod: filters.paymentMethod || undefined,
      subStatus: filters.subStatus,
      business_unit_id: filters.selectedBusinessUnit,
      transactionStatus: filters.transactionStatus,
      additionalInfo: filters.additionalInfo,
      approvalStatus: filters.approvalStatus || undefined,
      dataMappings: filters.selectedDataMappings?.length
        ? filters.selectedDataMappings
        : undefined,
      smartpayablesId: filters.smartpayablesId || undefined,
      hasFilesAttached: filters.hasFilesAttached,
      customPaymentTypeId: filters.customPaymentTypeId || undefined,

      // pagination
      limit: filters.limit ?? 25,
      offset: filters.offSet,

      // sort
      orderByColumn: sort.sortBy.name,
      orderType: sort.sortBy.order == 1 ? 'ASC' : 'DESC',

      isError: filters.isError,
      hasPayImmediately: filters.hasPayImmediately,
    };
  };

  static getRefundWithLineItems = (refundId, refundLocation) => {
    return axios.get(
      API_BASE_URL + `/refund-with-line-items/${refundLocation}/${refundId}`,
    );
  };

  static getStatusHistory = (refundId) => {
    return axios.get(API_BASE_URL + `/status_history/transactions/${refundId}`);
  };

  static getRefundInfoHistory = (id) => {
    return axios.get(API_BASE_URL + `/get_refund_info_history/` + id);
  };

  static toggleDelete = (refundId) => {
    return axios.get(API_BASE_URL + `/toggle_delete/${refundId}`);
  };

  static cancelRefund = (refundId, comment) => {
    return axios.post(
      API_BASE_URL + `/cancel-refund/transactions/${refundId}`,
      {
        comment: comment,
      },
    );
  };

  static downloadReport = (filters) => {
    return axios.get(
      API_BASE_URL + `/downloadReport?filters=` + JSON.stringify(filters),
    );
  };

  static statusAction = (id, path, comment) => {
    return axios.post(API_BASE_URL + '/' + path + '/' + id, {
      params: { comment },
    });
  };

  static editRefund = (refund, refundLocation, formData, updateStatus) => {
    const endpoint = refund
      ? `${API_BASE_URL}/edit-refund/${refundLocation}/${refund.id}?updateStatus=${updateStatus}&facilityId=${refund.facility_id}`
      : `${API_BASE_URL}/create-refund`;

    return axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  static validateRefund = (refund, formData) => {
    return axios.post(`${API_BASE_URL}/validate-refund`, formData, {
      params: {
        facilityId: refund.facility_id,
        refundId: refund.id || undefined,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  static resendCommunication = (refundId) => {
    return axios.get(`${API_BASE_URL}/resend-communication/${refundId}`);
  };
}
